var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c("SearchTerm", {
        attrs: {
          searchInfo: _vm.searchInfo,
          searchMore: true,
          searchBaseItems: [
            "activeStationId",
            "svcGroupId",
            "mobile",
            "svcNumber"
          ],
          btns: { search: true, reset: true }
        },
        on: { onChange: function() {} }
      }),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          small: "",
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "div",
        { staticClass: "bairun-table-btns" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
            [_vm._v("新增储值卡")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onRecharge } },
            [_vm._v("大客户充值")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onCredit } },
            [_vm._v("授权业务")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onAddOrReduce } },
            [_vm._v("余额扣减")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onLose } },
            [_vm._v("办理挂失")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onUnLose } },
            [_vm._v("办理解失")]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          ref: "svcBalanceTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            height: "45rem",
            "tooltip-effect": "dark"
          },
          on: {
            "selection-change": _vm.handleSelChange,
            "row-click": function(row) {
              _vm.onClickRow(row)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "ID", width: "40", type: "selection" }
          }),
          _c("el-table-column", {
            attrs: { label: "储值卡卡号", prop: "svcNumber", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.svcNumber))]),
                    scope.row.sanshanSvcNumber
                      ? _c("div", [
                          _vm._v(
                            "(旧:" + _vm._s(scope.row.sanshanSvcNumber) + ")"
                          )
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "用户电话", prop: "mobile", width: "110" }
          }),
          _c("el-table-column", {
            attrs: { label: "车牌", prop: "carNumber" }
          }),
          _c("el-table-column", { attrs: { label: "姓名", prop: "fullName" } }),
          _c("el-table-column", {
            attrs: { label: "余额(元)", prop: "balance" }
          }),
          _c("el-table-column", {
            attrs: { label: "卡群组", prop: "svcGroupName", width: "120" }
          }),
          _c("el-table-column", {
            attrs: { label: "发卡日期", prop: "activeDate", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDate")(scope.row.activeDate)))
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "发卡油站", prop: "activeStationId", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm.allStationMap[String(scope.row.activeStationId)]
                          .stationName
                      )
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "可使用油品", prop: "oilCodes" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(_vm._f("getOilCodeNames")(scope.row.oilCodes))
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "开票类型", prop: "invoiceType" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.invoiceType == 0
                      ? _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "primary" } },
                          [_vm._v("消费开票")]
                        )
                      : scope.row.invoiceType == 1
                      ? _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "success" } },
                          [_vm._v("消费不开票")]
                        )
                      : _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "success" } },
                          [_vm._v("-")]
                        )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "企业名称", prop: "companyName" }
          }),
          _c("el-table-column", {
            attrs: { label: "副卡数", prop: "subCardNum" }
          }),
          _c("el-table-column", {
            attrs: { label: "账户状态", prop: "svcStatus" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.svcStatus == 1
                      ? _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "primary" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.filterDict(scope.row.svcStatus, "svcStatus")
                              )
                            )
                          ]
                        )
                      : _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "danger" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.filterDict(scope.row.svcStatus, "svcStatus")
                              )
                            )
                          ]
                        )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作区", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-dropdown",
                      { attrs: { trigger: "click" } },
                      [
                        _c("el-button", [
                          _vm._v("更多"),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right"
                          })
                        ]),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.onView(scope.row)
                                  }
                                }
                              },
                              [
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { icon: "el-icon-view" } },
                                  [_vm._v("查看")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.onUpdate(scope.row)
                                  }
                                }
                              },
                              [
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { icon: "el-icon-edit" } },
                                  [_vm._v("编辑")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.onClose,
            visible: _vm.viewVisible,
            title: "查看操作"
          },
          on: {
            "update:visible": function($event) {
              _vm.viewVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: { model: _vm.formData, "label-position": "right" }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡号:", prop: "svcNumber" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.svcNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "svcNumber", $$v)
                              },
                              expression: "formData.svcNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡状态:" } },
                        [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: _vm.formData.svcStatus,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "svcStatus", $$v)
                                },
                                expression: "formData.svcStatus"
                              }
                            },
                            _vm._l(_vm.svcStatusOptions, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "余额(元):", prop: "balance" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.balance,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "balance", $$v)
                              },
                              expression: "formData.balance"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "累计消费(元):", prop: "consumeSum" }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.consumeSum,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "consumeSum", $$v)
                              },
                              expression: "formData.consumeSum"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡群组:", prop: "svcGroupId" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.svcGroupName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "svcGroupName", $$v)
                              },
                              expression: "formData.svcGroupName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "企业名称:", prop: "companyName" } },
                        [
                          _c("el-input", {
                            attrs: { value: _vm.formData.companyName }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户电话:", prop: "mobile" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.mobile,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "mobile", $$v)
                              },
                              expression: "formData.mobile"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户姓名:" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.fullName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "fullName", $$v)
                              },
                              expression: "formData.fullName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "身份证:" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.idCard,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "idCard", $$v)
                              },
                              expression: "formData.idCard"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "车牌号:" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.carNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "carNumber", $$v)
                              },
                              expression: "formData.carNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "发卡油站:", prop: "activeStationId" }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value:
                                _vm.allStationMap[
                                  String(_vm.formData.activeStationId)
                                ].stationName
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "发卡日期:", prop: "activeDate" } },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm._f("formatDate")(
                                _vm.formData.activeDate
                              )
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "副卡数量:", prop: "subCardNum" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.subCardNum,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "subCardNum", $$v)
                              },
                              expression: "formData.subCardNum"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "备注:" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "remark", $$v)
                              },
                              expression: "formData.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "累计授权(元):", prop: "preSum" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.preSum,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "preSum", $$v)
                              },
                              expression: "formData.preSum"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "累计回款(元):", prop: "returnedSum" }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.returnedSum,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "returnedSum", $$v)
                              },
                              expression: "formData.returnedSum"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "消费限制：", prop: "payLimit" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.payLimit,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "payLimit", $$v)
                                },
                                expression: "formData.payLimit"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("加油、便利店均可用")
                              ]),
                              _c("el-radio", { attrs: { label: 5 } }, [
                                _vm._v("仅加油消费")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否授权账户:" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.accountType,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "accountType", $$v)
                                },
                                expression: "formData.accountType"
                              }
                            },
                            _vm._l(_vm.svcAccountTypeOptions, function(item) {
                              return _c(
                                "el-radio",
                                { attrs: { label: item.value } },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "可使用油品:", prop: "oilCodes" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: { change: _vm.handleCheckAllChange },
                              model: {
                                value: _vm.oilCodesCheckAll,
                                callback: function($$v) {
                                  _vm.oilCodesCheckAll = $$v
                                },
                                expression: "oilCodesCheckAll"
                              }
                            },
                            [_vm._v("全选")]
                          ),
                          _c(
                            "el-checkbox-group",
                            {
                              on: { change: _vm.handleCheckedOilCodesChange },
                              model: {
                                value: _vm.oilCodesChecked,
                                callback: function($$v) {
                                  _vm.oilCodesChecked = $$v
                                },
                                expression: "oilCodesChecked"
                              }
                            },
                            _vm._l(_vm.oilCodesOptions, function(oil) {
                              return _c(
                                "el-checkbox",
                                { key: oil.value, attrs: { label: oil.value } },
                                [_vm._v(_vm._s(oil.label))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否记账：", prop: "payType" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.payType,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "payType", $$v)
                                },
                                expression: "formData.payType"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 5 } }, [
                                _vm._v("是")
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("否")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "最后操作人:" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.formData.sysUserName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "sysUserName", $$v)
                              },
                              expression: "formData.sysUserName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "开票类型：", prop: "invoiceType" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.invoiceType,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "invoiceType", $$v)
                                },
                                expression: "formData.invoiceType"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("消费开票")
                              ]),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("消费不开票")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "最后操作时间:" } },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm._f("formatDate")(
                                _vm.formData.UpdatedAt
                              )
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [_c("el-button", { on: { click: _vm.onClose } }, [_vm._v("关闭")])],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.onClose,
            visible: _vm.addAndUpdateVisible,
            title: _vm.addAndUpdateTitle
          },
          on: {
            "update:visible": function($event) {
              _vm.addAndUpdateVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                rules: _vm.getRule,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡号:" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "请输入",
                              disabled: true
                            },
                            model: {
                              value: _vm.formData.svcNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "svcNumber", $$v)
                              },
                              expression: "formData.svcNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "发卡油站:", prop: "activeStationId" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                                disabled: _vm.type == "update"
                              },
                              on: { change: _vm.inputChange },
                              model: {
                                value: _vm.formData.activeStationId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "activeStationId", $$v)
                                },
                                expression: "formData.activeStationId"
                              }
                            },
                            _vm._l(_vm.allStations, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户电话:", prop: "mobile" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "请输入",
                              maxlength: "11",
                              disabled: _vm.type == "update"
                            },
                            model: {
                              value: _vm.formData.mobile,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "mobile", $$v)
                              },
                              expression: "formData.mobile"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户姓名:" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.formData.fullName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "fullName", $$v)
                              },
                              expression: "formData.fullName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "身份证:" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.formData.idCard,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "idCard", $$v)
                              },
                              expression: "formData.idCard"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "车牌号:" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.formData.carNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "carNumber", $$v)
                              },
                              expression: "formData.carNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡群组:", prop: "svcGroupId" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                clearable: "",
                                remote: "",
                                placeholder: "关键词",
                                "remote-method": _vm.onSearchSvcGroup
                              },
                              model: {
                                value: _vm.formData.svcGroupId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "svcGroupId", $$v)
                                },
                                expression: "formData.svcGroupId"
                              }
                            },
                            _vm._l(_vm.svcGroupOptions, function(item) {
                              return _c("el-option", {
                                key: item.groupId,
                                attrs: {
                                  label: item.groupName,
                                  value: item.groupId
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "企业名称:" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.formData.companyName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "companyName", $$v)
                              },
                              expression: "formData.companyName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "可使用油品:", prop: "oilCodes" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: { change: _vm.handleCheckAllChange },
                              model: {
                                value: _vm.oilCodesCheckAll,
                                callback: function($$v) {
                                  _vm.oilCodesCheckAll = $$v
                                },
                                expression: "oilCodesCheckAll"
                              }
                            },
                            [_vm._v("全选")]
                          ),
                          _c(
                            "el-checkbox-group",
                            {
                              on: { change: _vm.handleCheckedOilCodesChange },
                              model: {
                                value: _vm.oilCodesChecked,
                                callback: function($$v) {
                                  _vm.oilCodesChecked = $$v
                                },
                                expression: "oilCodesChecked"
                              }
                            },
                            _vm._l(_vm.oilCodesOptions, function(oil) {
                              return _c(
                                "el-checkbox",
                                { key: oil.value, attrs: { label: oil.value } },
                                [_vm._v(_vm._s(oil.label))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否记账：", prop: "payType" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.payType,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "payType", $$v)
                                },
                                expression: "formData.payType"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 5 } }, [
                                _vm._v("是")
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("否")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "账户状态", prop: "svcStatus" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "", placeholder: "请选择" },
                              model: {
                                value: _vm.formData.svcStatus,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "svcStatus", $$v)
                                },
                                expression: "formData.svcStatus"
                              }
                            },
                            _vm._l(_vm.svcStatusOptions, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否授权账户:" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.accountType,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "accountType", $$v)
                                },
                                expression: "formData.accountType"
                              }
                            },
                            _vm._l(_vm.svcAccountTypeOptions, function(item) {
                              return _c(
                                "el-radio",
                                { attrs: { label: item.value } },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _vm.type == "add"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "支付密码:", prop: "password" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "6",
                                  clearable: "",
                                  placeholder: "请输入"
                                },
                                model: {
                                  value: _vm.formData.password,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "password", $$v)
                                  },
                                  expression: "formData.password"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "开票类型:" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.invoiceType,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "invoiceType", $$v)
                                },
                                expression: "formData.invoiceType"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("消费开票")
                              ]),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("消费不开票")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "备注:" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.formData.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "remark", $$v)
                              },
                              expression: "formData.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.onClose } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.onClose,
            visible: _vm.rechargeVisible,
            title: "大客户充值操作"
          },
          on: {
            "update:visible": function($event) {
              _vm.rechargeVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "rechargeFormData",
              attrs: {
                model: _vm.formData,
                rules: _vm.getRule,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡号:", prop: "svcNumber" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.formData.svcNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "svcNumber", $$v)
                              },
                              expression: "formData.svcNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户姓名:" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.formData.fullName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "fullName", $$v)
                              },
                              expression: "formData.fullName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户电话:", prop: "mobile" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "11", disabled: "" },
                            model: {
                              value: _vm.formData.mobile,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "mobile", $$v)
                              },
                              expression: "formData.mobile"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡群组:", prop: "svcGroupId" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.formData.svcGroupName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "svcGroupName", $$v)
                              },
                              expression: "formData.svcGroupName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "企业名称:" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.formData.companyName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "companyName", $$v)
                              },
                              expression: "formData.companyName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "发卡油站:", prop: "activeStationId" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { filterable: "", disabled: "" },
                              model: {
                                value: _vm.formData.activeStationId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "activeStationId", $$v)
                                },
                                expression: "formData.activeStationId"
                              }
                            },
                            _vm._l(_vm.allStations, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "余额(元):", prop: "balance" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.formData.balance,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "balance", $$v)
                              },
                              expression: "formData.balance"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "充值油站:",
                            prop: "rechargeStationId"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择"
                              },
                              on: { change: _vm.inputChange },
                              model: {
                                value: _vm.formData.rechargeStationId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "rechargeStationId",
                                    $$v
                                  )
                                },
                                expression: "formData.rechargeStationId"
                              }
                            },
                            _vm._l(_vm.allStations, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "充值金额(元):",
                            prop: "rechargeBalance"
                          }
                        },
                        [
                          _c("el-input-number", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.formData.rechargeBalance,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "rechargeBalance", $$v)
                              },
                              expression: "formData.rechargeBalance"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "支付方式:",
                            prop: "rechargePayChannel"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择"
                              },
                              model: {
                                value: _vm.formData.rechargePayChannel,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "rechargePayChannel",
                                    $$v
                                  )
                                },
                                expression: "formData.rechargePayChannel"
                              }
                            },
                            _vm._l(_vm.payChannelOptions, function(item) {
                              return _c("el-option", {
                                key: item.payChannel,
                                attrs: {
                                  label: item.cnName,
                                  value: item.payChannel
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "备注:", prop: "optDescribe" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.formData.optDescribe,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "optDescribe", $$v)
                              },
                              expression: "formData.optDescribe"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.onClose } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.onClose,
            visible: _vm.creditVisible,
            title: "授权操作"
          },
          on: {
            "update:visible": function($event) {
              _vm.creditVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "creditFormData",
              attrs: { model: _vm.formData, "label-position": "right" }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡号:", prop: "svcNumber" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.formData.svcNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "svcNumber", $$v)
                              },
                              expression: "formData.svcNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户电话:", prop: "mobile" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "11", disabled: "" },
                            model: {
                              value: _vm.formData.mobile,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "mobile", $$v)
                              },
                              expression: "formData.mobile"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "发卡油站:", prop: "activeStationId" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { filterable: "", disabled: "" },
                              model: {
                                value: _vm.formData.activeStationId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "activeStationId", $$v)
                                },
                                expression: "formData.activeStationId"
                              }
                            },
                            _vm._l(_vm.allStations, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡群组:", prop: "svcGroupId" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.formData.svcGroupName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "svcGroupName", $$v)
                              },
                              expression: "formData.svcGroupName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "企业名称:" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.formData.companyName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "companyName", $$v)
                              },
                              expression: "formData.companyName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "余额(元):", prop: "balance" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.formData.balance,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "balance", $$v)
                              },
                              expression: "formData.balance"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "可使用油品:", prop: "oilCodes" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.oilCodesChecked,
                                callback: function($$v) {
                                  _vm.oilCodesChecked = $$v
                                },
                                expression: "oilCodesChecked"
                              }
                            },
                            _vm._l(_vm.oilCodesOptions, function(oil) {
                              return _c(
                                "el-checkbox",
                                { key: oil.value, attrs: { label: oil.value } },
                                [_vm._v(_vm._s(oil.label))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "bairun-required",
                          attrs: { label: "操作油站:", prop: "stationId" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择"
                              },
                              on: { change: _vm.inputChange },
                              model: {
                                value: _vm.formData.stationId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "stationId", $$v)
                                },
                                expression: "formData.stationId"
                              }
                            },
                            _vm._l(_vm.allStations, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "bairun-required",
                          attrs: { label: "金额(元):" }
                        },
                        [
                          _c("el-input-number", {
                            attrs: {
                              clearable: "",
                              placeholder: "正数为授钱，负数为扣减"
                            },
                            model: {
                              value: _vm.formData.creditBalance,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "creditBalance", $$v)
                              },
                              expression: "formData.creditBalance"
                            }
                          }),
                          _c("i", { staticClass: "svc-credit-type" }, [
                            _vm._v("授权业务不产生财务对账单")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "备注:", prop: "optDescribe" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.formData.optDescribe,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "optDescribe", $$v)
                              },
                              expression: "formData.optDescribe"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.onClose } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.onClose,
            visible: _vm.addOrReduceVisible,
            title: "扣减操作"
          },
          on: {
            "update:visible": function($event) {
              _vm.addOrReduceVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "addOrReduceFormData",
              attrs: { model: _vm.formData, "label-position": "right" }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡号:", prop: "svcNumber" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入", disabled: "" },
                            model: {
                              value: _vm.formData.svcNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "svcNumber", $$v)
                              },
                              expression: "formData.svcNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "余额(元):", prop: "balance" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.formData.balance,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "balance", $$v)
                              },
                              expression: "formData.balance"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户电话:", prop: "mobile" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入",
                              maxlength: "11",
                              disabled: ""
                            },
                            model: {
                              value: _vm.formData.mobile,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "mobile", $$v)
                              },
                              expression: "formData.mobile"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "发卡油站:", prop: "activeStationId" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { filterable: "", disabled: "" },
                              model: {
                                value: _vm.formData.activeStationId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "activeStationId", $$v)
                                },
                                expression: "formData.activeStationId"
                              }
                            },
                            _vm._l(_vm.allStations, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡群组:", prop: "svcGroupId" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.formData.svcGroupName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "svcGroupName", $$v)
                              },
                              expression: "formData.svcGroupName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "企业名称:" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.formData.companyName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "companyName", $$v)
                              },
                              expression: "formData.companyName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "bairun-required",
                          attrs: { label: "操作油站:", prop: "stationId" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择"
                              },
                              on: { change: _vm.inputChange },
                              model: {
                                value: _vm.formData.stationId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "stationId", $$v)
                                },
                                expression: "formData.stationId"
                              }
                            },
                            _vm._l(_vm.allStations, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "备注:", prop: "optDescribe" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.formData.optDescribe,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "optDescribe", $$v)
                              },
                              expression: "formData.optDescribe"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "bairun-required",
                          attrs: { label: "扣减类型:", prop: "reduceType" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              on: {
                                change: function() {
                                  this$1.inputChange()
                                  this$1.formData.payChannel = ""
                                }
                              },
                              model: {
                                value: _vm.formData.reduceType,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "reduceType", $$v)
                                },
                                expression: "formData.reduceType"
                              }
                            },
                            [
                              _c("el-option", {
                                key: 1,
                                attrs: { label: "仅扣减余额", value: 1 }
                              }),
                              _c("el-option", {
                                key: 2,
                                attrs: { label: "退款", value: 2 }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "bairun-required",
                          attrs: { label: "扣减金额(元):" }
                        },
                        [
                          _c("el-input-number", {
                            attrs: {
                              clearable: "",
                              placeholder: "输入正数",
                              min: 0
                            },
                            model: {
                              value: _vm.formData.reduceBalance,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "reduceBalance", $$v)
                              },
                              expression: "formData.reduceBalance"
                            }
                          }),
                          _c("i", { staticClass: "svc-credit-type" }, [
                            _vm._v("产生财务对账单记录")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _vm.formData.reduceType == 2
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "bairun-required",
                              attrs: { label: "付款方式:", prop: "payChannel" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    filterable: "",
                                    placeholder: "请选择"
                                  },
                                  model: {
                                    value: _vm.formData.payChannel,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "payChannel", $$v)
                                    },
                                    expression: "formData.payChannel"
                                  }
                                },
                                _vm._l(_vm.payChannelOptions, function(item) {
                                  return _c("el-option", {
                                    key: item.payChannel,
                                    attrs: {
                                      label: item.cnName,
                                      value: item.payChannel
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.onClose } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.onClose,
            visible: _vm.loseOrCancelVisible,
            title:
              _vm.type == "lose"
                ? "挂失操作:"
                : _vm.type == "unlose"
                ? "解挂操作:"
                : ""
          },
          on: {
            "update:visible": function($event) {
              _vm.loseOrCancelVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "loseFormData",
              attrs: {
                model: _vm.formData,
                rules: _vm.getRule,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡号:", prop: "svcNumber" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.formData.svcNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "svcNumber", $$v)
                              },
                              expression: "formData.svcNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户电话:", prop: "mobile" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: "11", disabled: "" },
                            model: {
                              value: _vm.formData.mobile,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "mobile", $$v)
                              },
                              expression: "formData.mobile"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "发卡油站:", prop: "activeStationId" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { filterable: "", disabled: "" },
                              model: {
                                value: _vm.formData.activeStationId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "activeStationId", $$v)
                                },
                                expression: "formData.activeStationId"
                              }
                            },
                            _vm._l(_vm.allStations, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡群组:", prop: "svcGroupId" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.formData.svcGroupName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "svcGroupName", $$v)
                              },
                              expression: "formData.svcGroupName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "企业名称:" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", disabled: "" },
                            model: {
                              value: _vm.formData.companyName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "companyName", $$v)
                              },
                              expression: "formData.companyName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "余额(元):", prop: "balance" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.formData.balance,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "balance", $$v)
                              },
                              expression: "formData.balance"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "累计消费(元):", prop: "consumeSum" }
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.formData.consumeSum,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "consumeSum", $$v)
                              },
                              expression: "formData.consumeSum"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.type == "lose" ? "挂失原因:" : "解挂说明",
                            prop: "optDescribe"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.formData.optDescribe,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "optDescribe", $$v)
                              },
                              expression: "formData.optDescribe"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.onClose } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }